import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { 
  BookOpen, 
  Certificate, 
  ChartBar, 
  Users, 
  Folders,
  FileText,
  GraduationCap,
  ClockCounterClockwise,
  Buildings
} from '@phosphor-icons/react';

const ADMIN_NAV = [
  { path: '/admin', label: 'Dashboard', icon: ChartBar },
  { path: '/admin/courses', label: 'Gerenciar Cursos', icon: Folders },
  { path: '/admin/users', label: 'Gerenciar Usuarios', icon: Users },
  { path: '/admin/clients', label: 'Clientes', icon: Buildings },
  { path: '/admin/activity', label: 'Log de Atividades', icon: ClockCounterClockwise },
  { path: '/admin/reports', label: 'Relatorios', icon: FileText },
];

const CLIENT_ADMIN_NAV = [
  { path: '/company', label: 'Minha Empresa', icon: Buildings },
  { path: '/company/users', label: 'Usuarios', icon: Users },
  { path: '/company/reports', label: 'Relatorios', icon: FileText },
];

const LEARNER_NAV = [
  { path: '/my-learning', label: 'Meu Aprendizado', icon: GraduationCap },
  { path: '/courses', label: 'Catalogo de Cursos', icon: BookOpen },
  { path: '/certificates', label: 'Certificados', icon: Certificate },
];

export function Sidebar() {
  const location = useLocation();
  const { user } = useAuth();

  const role = user?.role;
  let navItems = LEARNER_NAV;
  let sectionLabel = 'Aprendizado';

  if (role === 'admin') {
    navItems = ADMIN_NAV;
    sectionLabel = 'Painel Admin';
  } else if (role === 'client_admin') {
    navItems = [...CLIENT_ADMIN_NAV, ...LEARNER_NAV];
    sectionLabel = 'Gestao';
  }

  return (
    <aside className="w-[220px] bg-white border-r border-[#2C3E50]/10 min-h-screen flex-shrink-0">
      <div className="p-4">
        <p className="text-xs font-bold uppercase tracking-[0.15em] text-[#5C6B7A] mb-4 px-3">
          {sectionLabel}
        </p>
        <nav className="space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-150 ${
                  isActive
                    ? 'bg-[#2C3E50] text-white shadow-md shadow-[#2C3E50]/20'
                    : 'text-[#5C6B7A] hover:bg-[#F8F9FA] hover:text-[#1A252F]'
                }`}
                data-testid={`nav-${item.path.replace(/\//g, '-')}`}
              >
                <Icon size={18} weight={isActive ? 'fill' : 'regular'} />
                {item.label}
              </Link>
            );
          })}
        </nav>

        {role === 'admin' && (
          <>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-[#5C6B7A] mt-6 mb-4 px-3">
              Acoes Rapidas
            </p>
            <Link
              to="/admin/courses"
              className="flex items-center gap-3 px-3 py-2.5 text-sm font-medium text-[#27AE60] hover:bg-[#27AE60]/5 rounded-xl transition-all"
            >
              <Folders size={18} />
              Novo Curso
            </Link>
          </>
        )}
      </div>
    </aside>
  );
}

export default Sidebar;
